<template>
    <div class="questions__container">
        <div class="questions__width">
            <span class="questions__title">{{ $t("lang.pages.tariff.questions.title") }}</span>
            <div class="questions__content">
                <div>
                    <span class="questions__content_title">{{ $t("lang.pages.tariff.questions.question_2") }}</span>
                    <div class="questions__content_answer">
                        <span>{{ $t("lang.pages.tariff.questions.answer_2") }}</span>
                    </div>
                </div>
                <div>
                    <span class="questions__content_title">{{ $t("lang.pages.tariff.questions.question_4") }}</span>
                    <div class="questions__content_answer">
                        <span>{{ $t("lang.pages.tariff.questions.answer_4_1") }}</span>
                        <span>{{ $t("lang.pages.tariff.questions.answer_4_2") }}</span>
                        <span>{{ $t("lang.pages.tariff.questions.answer_4_3") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TariffPageQuestions"
}
</script>

<style scoped>
.questions__container {
    background-color: #232D35;
    padding: 65px 0;
    color: #fff;
    background-image: url("/i/pages/tariff/question.svg");
    background-position: right 15% bottom 50px;
    background-repeat: no-repeat;
    background-size: 25%;
    border-bottom: 1px solid #a4b1be;
}
.questions__width {
    max-width: var(--keysso-max-width-content-large);
    margin: 0 auto;
    padding: var(--keysso-padding-content-container);
}
.questions__title {
    font-weight: 600;
    font-size: 35px;
    line-height: 38px;
    letter-spacing: -0.015em;
    margin-bottom: 32px;
    display: inline-block;
}
.questions__content {
    display: flex;
}
.questions__content > div {
    display: flex;
    flex-direction: column;
    flex: 1 50%;
}
.questions__content span {
    padding: 0 16px;
}
.questions__content_title {
    font-size: 20px;
    line-height: 32px;
    color: #70B319;
    margin-bottom: 8px;
}
.questions__content_answer {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    line-height: 24px;
    padding: 8px 0;
}
.questions__content_answer:not(:last-child) {
    margin-bottom: 32px;
}

@media (max-width: 1200px) {
    .questions__content {
        flex-direction: column;
    }
    .questions__content_answer {
        margin-bottom: 32px;
    }
}
</style>
